import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { SingleCase } from '@/widgets/case-management/single-case'

const searchSchemaValidation = z
  .object({
    scrollTo: z.string().optional(),
    noteId: z.string().optional(),
  })
  .catchall(z.unknown())

export const Route = createFileRoute('/_app/case-management/cases/$id')({
  component: RouteComponent,
  validateSearch: (search) => searchSchemaValidation.parse(search),
})

export const SingleCaseManagementCaseRoute = Route

function RouteComponent() {
  const { id } = SingleCaseManagementCaseRoute.useParams()

  return <SingleCase id={id} />
}
